export default [
  {
    path: '/:locale([en/]*)?/personal-information/detail/:id(\\d+)?',
    name: 'PolicyShare',
    component: () => import('@/views/policy/Index'),
    meta: {
      language: false,
      sitemap: { ignoreRoute: true }
    }
  },
  // 사용하지 않는 페이지 sustainability-together로 리다이렉트
  {
    path: '/:locale([en/]*)?/together/:category(\\d+)?',
    name: 'Writing',
    component: () => import('@/views/writing/Index'),
    redirect: { name: 'sustainability-together' },
    meta: {
      scroll: true,
      // language: false,
      sitemap: {
        loc: '/together'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/together/:category?/detail/:writingId(\\d+)?',
    name: 'writingDetail',
    component: () => import('@/views/writing/Detail'),
    redirect: { name: 'sustainability-together' },
    meta: {
      language: false,
      parent: 'Writing',
      sitemap: { ignoreRoute: true }
    }
  }
  // {
  // path: '/:locale([en]*)?/company/compliance/report',
  // name: 'ComplianceReport',
  // component: () => import('@/views/company/_old.ComplianceReport.vue'),
  // meta: {
  //   // scroll: true,
  //   // language: false,
  //   parent: 'Company',
  //   sitemap: { ignoreRoute: true }
  // }
  // },
  // {
  // path: '/:locale([en]*)?/credo',
  // name: 'Consult',
  // component: () => import('@/views/company/_old.credo/Index'),
  // redirect: { name: 'ConsultInfo' },
  // meta: {
  //   sitemap: {
  //     loc: '/credo'
  //   }
  // },
  // children: [
  //   {
  //     path: 'consult',
  //     name: 'ConsultInfo',
  //     component: () => import('@/views/company/_old.credo/Consult.vue'),
  //     meta: {
  //       language: false,
  //       parent: 'Consult'
  //     }
  //   },
  //   {
  //     path: 'form',
  //     name: 'ConsultForm',
  //     component: () => import('@/views/company/_old.credo/Report'),
  //     meta: {
  //       language: false,
  //       parent: 'Consult'
  //     }
  //   }
  // ]
  // },
]
